import { render, staticRenderFns } from "./recProd.vue?vue&type=template&id=1b3e3697&scoped=true"
import script from "./recProd.vue?vue&type=script&lang=js"
export * from "./recProd.vue?vue&type=script&lang=js"
import style0 from "./recProd.vue?vue&type=style&index=0&id=1b3e3697&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e3697",
  null
  
)

export default component.exports